import templateUrl from "emun.salesrep/sync-dashboard.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

class SyncDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    let $ctrl = this;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    let bus = new ServiceBus();
    $ctrl.syncData = [];
    $ctrl.tableName = "Select a link to see the data";
    $ctrl.subTypes = new AutoQuery({
      url: "QueryPresetQueries.json?Screen=Desktop Sync&GroupBy=SubType",
      autoLoad: true,
      orderBy: "subType",
      pageSize: 100,
      scrollTop: false,
      disableQueryString: true,
    });

    $ctrl.PresetQueries = new AutoQuery({
      url: "QueryPresetQueries.json?Screen=Desktop Sync",
      autoLoad: true,
      orderBy: "subType",
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          bus.send("QueryPresetRaw.json?Id=" + obj.id).then(
            function (response) {
              if (response != null) {
                var key = obj.Name + "Count";
                $ctrl[key] += response.data.length;
              }
              $ctrl.syncData.push({
                id: obj.id,
                name: obj.name,
                subType: obj.subType,
                count: response.data.length,
                data: response.data,
                active: false,
                dataHeaders:
                  response != null && response.data.length > 0
                    ? Object.keys(response.data[0])
                    : [],
              });
            },
            function error(res) {}
          );
        });
        console.info("$ctrl.syncData", $ctrl.syncData);
      },
      pageSize: 100,
    });

    this.$session = $session;
  }

  $onInit() {
    let $ctrl = this;
  }

  loadTable(id, data, header, name) {
    let $ctrl = this;
    console.info("data", data);
    $ctrl.tableName = name;
    $ctrl.tableData = data;
    $ctrl.tableHeader = header;
    $ctrl.tableId = id;
  }

  active(s) {
    let $ctrl = this;
    $ctrl.syncData.forEach(function (obj) {
      obj.active = false;
      if (obj.id === s.id) obj.active = true;
    });
  }

  downloadCSV(id, name = "Data.csv") {
    let $ctrl = this;
    console.info("name", name.replace(/\s/g, ""));
    let bus = new ServiceBus();
    var url = $ctrl.$appConfig.resolveServiceUrl("QueryPresetRaw.csv?Id=" + id);
    const link = document.createElement("a");
    link.download = name.replace(/\s/g, "");
    link.href = url;
    console.debug("link.href", link.href);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

let SyncDashboard = {
  bindings: {
    repId: "@",
  },
  controller: SyncDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default SyncDashboard;
